import "core-js/modules/es.array.push.js";
import DomUtil from "@/utils/dom";
import Utils from "@/utils/utils";
export default {
  props: {
    isMobile: Boolean,
    targetList: {
      // [{ name: 'business', jumpTo: '.template-card-business' }]
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      tableList: [{
        type: "business",
        content: "inspo_table_business"
      }, {
        type: "video",
        content: "inspo_table_video"
      }, {
        type: "artists",
        content: "inspo_table_artists"
      }, {
        type: "musicians",
        content: "inspo_table_musicians"
      }, {
        type: "gaming",
        content: "inspo_table_gaming"
      }, {
        type: "sensitive",
        content: "inspo_table_sensitive"
      }],
      showTable: false,
      fixBottomHeight: 0,
      isFixBottom: false,
      target: "",
      scrollContainerEl: null,
      targetDomList: [],
      flag: true // 给予500ms 时间用来阻止自己选择触发的滚动修改target值
    };
  },

  beforeMount() {
    this.target = this.targetList[0] ? this.targetList[0].name : "";
  },
  mounted() {
    if (this.targetList.length) {
      this.$nextTick(() => {
        this.scrollContainerEl = DomUtil.getScrollContainer(document.querySelector("#templateInspoWrapper"), true);

        // scrollContainerEl 添加 滚动事件
        // 添加监听事件
        this.scrollContainerEl.addEventListener("scroll", Utils.throttle(this.onScroll, 50), false);
        let containerOffsetTop = DomUtil.getOffsetTop(this.scrollContainerEl);
        if (!this.isMobile) {
          let templateInspo = document.querySelector(".template-inspo-wrapper").getBoundingClientRect();
          let cardTableReact = document.querySelector("#cardTableP").getBoundingClientRect();
          this.fixBottomHeight = templateInspo.height - cardTableReact.height;
        }
        let targetDomList = [];
        let defaultTop = this.isMobile ? 144 : 130; // 导航高度
        this.targetList.forEach(t => {
          let targetDom = document.querySelector(t.jumpTo);
          if (targetDom) {
            let targetDomOffsetTop = DomUtil.getOffsetTop(targetDom);
            targetDomList.push({
              name: t.name,
              height: targetDomOffsetTop - containerOffsetTop - defaultTop
            });
          }
        });
        if (targetDomList.length > 1) {
          targetDomList.sort((a, b) => a.height - b.height);
        }
        this.targetDomList = targetDomList;
        this.initHashLocation();
      });
    }
  },
  methods: {
    toggleTable() {
      this.showTable = !this.showTable;
    },
    onScroll(event) {
      event = event || window.event;
      if (!event) return;
      let info = event.target || event.srcElement;
      if (!this.flag) return;
      if (!this.isMobile && this.fixBottomHeight) {
        if (info.scrollTop >= this.fixBottomHeight) {
          !this.isFixBottom && (this.isFixBottom = true);
        } else {
          this.isFixBottom && (this.isFixBottom = false);
        }
      }
      let targetLen = this.targetDomList.length;
      if (targetLen > 1) {
        let targetHeights = this.targetDomList.map(t => t.height);
        let targetIdx = 0;
        if (info.scrollTop >= targetHeights[targetLen - 1]) {
          targetIdx = targetLen - 1;
        } else {
          for (let i = 0; i < targetLen - 1; i++) {
            let currentH = targetHeights[i];
            let nextH = targetHeights[i + 1];
            if (info.scrollTop >= currentH && info.scrollTop < nextH) {
              targetIdx = i;
              break;
            }
          }
        }
        let currentTargetDom = this.targetDomList[targetIdx];
        this.target = currentTargetDom.name;
      }
    },
    initHashLocation() {
      let hashName = this.$route.hash && decodeURIComponent(this.$route.hash.split("#")[1]);
      if (hashName) {
        this.selectChange({
          type: hashName
        }, true);
      }
    },
    scrollTo(height) {
      this.$nextTick(() => {
        // document.querySelector(`.${this.scrollContainerEl.className}`).scrollTop = height;
        // console.log('this.scrollContainerEl.scrollTop=>', this.scrollContainerEl.scrollTop);
        // let currentScrollTop = this.scrollContainerEl.scrollTop;
        // let speed = Math.ceil((height - currentScrollTop)/20);
        // let timer = setInterval(() => {
        //     if (currentScrollTop >= height) {
        //         clearInterval(timer);
        //     } else {
        //         let distance = height - currentScrollTop;
        //         currentScrollTop +=  Math.abs(distance) >= speed ? speed : distance;
        //         console.log('currentScrollTop + speed', currentScrollTop + speed, 'speed', speed)
        //         this.scrollContainerEl.scrollTop = currentScrollTop;
        //     }
        // }, 10);
        if (this.scrollContainerEl == window) {
          window.scrollTo(0, height);
        } else {
          this.scrollContainerEl.scrollTop = height;
        }
      });
    },
    selectChange(info, isHash, isMobile) {
      let currentTarget = this.targetDomList.find(t => t.name === info.type);
      if (currentTarget) {
        if (isHash) {
          this.target = info.type;
        } else {
          location.hash = info.type;
        }
        this.flag = false;
        if (isMobile) {
          this.showTable = false;
        }
        this.scrollTo(currentTarget.height);
        setTimeout(() => {
          this.flag = true;
        }, 500);
      }
    }
  },
  beforeUnmount() {
    this.scrollContainerEl.removeEventListener("scroll", Utils.throttle(this.onScroll, 50), false);
  }
};